<template>
  <div class="text-bubble">
    <BubbleHeader v-if="isReminder">{{$t('client.matters.conversation.reminder_bubble_title')}}</BubbleHeader>
    <BubbleHeader v-if="shouldShowTitle">{{message.title}}</BubbleHeader>
    <BubbleHeader v-if="message.subject">
      <div>{{message.subject}}</div>
    </BubbleHeader>
    <BubbleTextRow v-if="shouldShowText"><BubbleTextMsg :text="message.text" /></BubbleTextRow>
  </div>
</template>

<script>

import {
  BubbleHeader,
  BubbleTextRow,
  BubbleTextMsg
} from './helpers'

export default {
  name: 'TextBubble',
  components: {
    BubbleHeader,
    BubbleTextRow,
    BubbleTextMsg,
  },
  props: {
    message: {
      type: Object,
      required: true,
    },
  },
  computed: {
    isReminder() {
      return this.message.message_type === "engagement_reminder"
    },
    isAssigned() {
      return this.message.message_type === "engagement_assigned" || this.message.message_type === "matter_assigned"
    },
    shouldShowTitle() {
      return this.isAssigned || this.message.message_type === "close_open_payments"
    },
    shouldShowText() {
      return this.message.message_type !== "close_open_payments"
    }
  }
}
</script>
